import { memo, forwardRef } from 'react';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

type SidebarToggleButtonProps = Omit<IconButtonProps, 'onClick'> & {
    open: boolean;
    onToggle: () => void;
};

const SidebarToggleButton = forwardRef<HTMLButtonElement, SidebarToggleButtonProps>(
    function SidebarToggleButton({ open, onToggle, ...iconButtonProps }, ref) {
        return (
            <IconButton ref={ref} color="inherit" size="medium" onClick={onToggle} {...iconButtonProps}>
                {open ? <MenuOpenRoundedIcon /> : <MenuRoundedIcon />}
            </IconButton>
        );
    }
);

export default memo(SidebarToggleButton);
